import type { CSSProperties } from "react";

export interface BrandMarkProps {
  compact?: boolean;
  inverse?: boolean;
  name?: string;
  subtitle?: string;
}

export function BrandMark({
  compact = false,
  inverse = false,
  name = "云猫 ERP",
  subtitle,
}: BrandMarkProps) {
  const textColor = inverse ? "#ffffff" : "#1b2924";
  const subtitleColor = inverse ? "rgba(255,255,255,.58)" : "#7b8580";
  const textStyle: CSSProperties = { color: textColor };
  return (
    <div className="brand-mark" aria-label={name}>
      <span className="brand-mark__symbol" aria-hidden="true">
        <svg viewBox="0 0 48 40" focusable="false">
          <path d="M26.2 30H10.6a6.6 6.6 0 0 1-1.2-13.1A10.4 10.4 0 0 1 29 13.5a7.9 7.9 0 0 1 8.3 11.3" />
          <path d="M36 22.5v2.2m0 8.6v2.2m-6.5-6.5h2.2m8.6 0h2.2m-11.1-4.6 1.6 1.5m6 6.1 1.6 1.6m0-9.2-1.6 1.5m-6 6.1-1.6 1.6" />
          <path d="M40.5 29a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0Z" />
        </svg>
      </span>
      {!compact && (
        <span className="brand-mark__copy">
          <strong style={textStyle}>{name}</strong>
          <small style={{ color: subtitleColor }}>
            {subtitle ?? "企业资源计划系统"}
          </small>
        </span>
      )}
    </div>
  );
}
